import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'

import type { ITheme } from '@homeviews/styles'
import { MediaCore } from '@homeviews/media'
import { Typography, WindowTitle } from '@homeviews/shared-ui'

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    root: {
      padding: theme.spacing(
        theme.layout.contentHorizontalPadding,
        theme.layout.contentVerticalPadding,
      ),
    },
  }),
)

const Guides: React.FC = () => {
  const classes = useStyles()
  return (
    <>
      <WindowTitle title="Guides" />
      <div className={classes.root}>
        <Typography variant="h1">Guides</Typography>
        <MediaCore
          libraryType="guides"
          header="Files"
          formats="docx,gif,jpg,mp4,pdf,png,pptx,svg,zip"
          defaultView="table"
          disabledCardsView
        />
      </div>
    </>
  )
}

export default Guides
